import sala from './salaRepository'
import setor from './setorRepository'
import unidadeExterna from './unidadeExternaRepository'
import unidade from './unidadeRepository'

export default baseUrl => {
    return {
        sala: sala(baseUrl),
        setor: setor(baseUrl),
        unidadeExterna: unidadeExterna(baseUrl),
        unidade: unidade(baseUrl),
    }
}